import { useState } from 'react';
import { CustomAlert, CustomButton, Text } from '../../../shared/uiComponents';
import { Bars } from '../../../shared/Assets/menuIcons';
import { PEARL } from '../../../shared/Helpers/colors';
import { Tab, TabsContainer } from '../../../shared/uiComponents/Tabs';

interface MobileClientTabsProps {
	activeTab: number;

	headers: string[];
	onTabChange: (index: number) => void;
}

const MobileClientTabs = ({ headers, activeTab, onTabChange }: MobileClientTabsProps) => {
	const [open, setOpen] = useState<boolean>(false);

	const handleTabClick = (index: number) => {
		onTabChange(index);
		setOpen(false);
	};

	const TabsContent = () => (
		<TabsContainer className="tabs">
			{headers.map((header, index) => (
				<Tab
					onClick={() => handleTabClick(index)}
					key={index}
					id={`${index}`}
					selected={index === activeTab}
					style={{ cursor: 'pointer' }}
				>
					<Text title={header} type="psm" fontWeight={index === activeTab ? 'semiBold' : 'medium'} />
				</Tab>
			))}
		</TabsContainer>
	);

	return (
		<>
			<CustomButton iconOnly={<Bars color={PEARL.BASE[600]} />} buttonType="quaternary" onClick={() => setOpen(true)} />
			<CustomAlert open={open} title={headers[activeTab]} onClose={() => setOpen(false)} Content={TabsContent} />
		</>
	);
};

export default MobileClientTabs;
